<template>
  <v-dialog
    v-model="show"
    width="650px"
    content-class="rounded-xl"
  >
    <v-card rounded="xl">
      <v-card-title>
         Внимание!!!
      </v-card-title>
      <v-divider/>
      <v-card-text class="text-subtitle-1">
        Если вы планируете отправить контракт на проверку, убедитесь, что
        <span class="text-h6">базовые</span>
        и
        <span class="text-h6">стимулирующие</span>
        части заполнены правильно.
        Обратите внимание, что после отправки вы не сможете изменить или добавить данные.
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="show = false"
          class="rounded-xl"
          color="teal darken-3"
          outlined
        >
          Отмена
        </v-btn>
        <v-btn
          @click="sentToReview"
          class="rounded-xl white--text"
          color="teal darken-3 "
        >
          Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "TheShippingAlertDialog",

  props: {
    visible: Boolean,
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },

  methods: {
    ...mapActions({
      sentReviewContracts: "effective_contract/sentReviewContracts",
    }),

    async sentToReview() {
      await this.sentReviewContracts();
      this.show = false;
    },
  },
}
</script>

<style scoped>

</style>